class ProductCardCarousel extends HTMLElement {
  constructor() {
    super();
    this.carousel = this
    this.closest('.product-card').addEventListener('mouseenter', () => this.init())
  }
  
  init() {
    const card_carousel = {
      class: `.product-card__carousel--${this.dataset.id}`,
      alias: 'card_carousel',
      config: {
        allowTouchMove: true,
        loop: true,
        slidesPerView: 1,
        initialSlide: 1,
        navigation: {
          prevEl: `.product-card__carousel--${this.dataset.id}__nav--prev`,
          nextEl: `.product-card__carousel--${this.dataset.id}__nav--next`,
        },
      }
    }

    window.swiperInstances = window.swiperInstances ? { ...swiperInstances, card_carousel} : { card_carousel }
    window.initCarousels()
  }

}

customElements.define('product-card-carousel', ProductCardCarousel);
